const $ = jQuery.noConflict();

'use strict';
/**
 * @description In order to create link that scrolls to certain section, simply place '#scroll-section-example' to a desired tag and id with same value to the section page should scroll to.
 * @description Alternately, you can enable any URL with# to autoscroll on page load. For example: some - website.com / #scroll - section - example
 * @example tag: <a class="btn" href="#scroll-section-example"> will scroll to: <div class="some-section" id="scroll-section-example">
 */
const ScrollTo = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domScrollLink: $('a[href*=\\#]:not([href=\\#])'),

	/** @description Initialize */
	init: function() {
		this.bindEvents();
		this.hashScroll();
		this.showItemWhenInViewport();
	},

	showItemWhenInViewport() {
		const elements = document.querySelectorAll('.js-story__title');
		elements.forEach(element => {
			this.observeItem(element);

			//Reload page check
			if (this.isElementInViewport(element)) {
				this.makeElementVisible(element);
			}
		});
	},

	observeItem(targetElement) {
		const callback = (entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.makeElementVisible(entry.target);
					observer.unobserve(entry.target); // Stop observing once the element is in view
				}
			});
		};

		const options = {
			root: null, // Use the viewport as the root
			rootMargin: '-200px',
			threshold: 0.1 // Trigger callback when 10% of the target is visible
		};

		const observer = new IntersectionObserver(callback, options);
		observer.observe(targetElement);
	},

	isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	},

	makeElementVisible(el) {
		el.parentElement.parentElement.classList.add('visible');
		el.classList.add('visible');
	},

	bindEvents() {
		this.$domScrollLink.on('click', (e) => {
			if (!e.target.classList.contains('js-allow-click')) {
				e.preventDefault();
			}
			const target = $(e.currentTarget.hash);
			const isCustomScroll = e.target.classList.contains('js-custom-scroll');

			if (isCustomScroll) {
				this.scrollToTarget(target, -100, 500);
			} else {
				this.scrollToTarget(target);
			}
		});
	},

	hashScroll() {
		const hash = window.location.hash;

		if (hash) {
			const target = $(hash);

			setTimeout(() => {
				const offset = target.data('scroll-offset') || 100;
				const scrollSpeed = target.data('scroll-speed') || 500;
				this.scrollToTarget(target, offset, scrollSpeed);
			}, 500);
		}
	},

	scrollToTarget(target, offset = 100, scrollSpeed = 1200) {
		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top - offset
			}, scrollSpeed);
		}
	}
};

export default ScrollTo;
